export const FilterBankGroup = (data, id) => {
  let o = Array.isArray(data) ? data : [];
  let a = id ? id : 0;

  let item = o?.find((i) => i.id === a);
  return item || undefined;
};
export const FilterMerchang = (data, id) => {
  let o = Array.isArray(data) ? data : [];
  let a = id ? id : 0;
  let item = o?.find((i) => i.id === a);
  return item  || undefined;
};
